import { render, staticRenderFns } from "./commonDocument.vue?vue&type=template&id=98b7d33a&scoped=true&"
import script from "./commonDocument.vue?vue&type=script&lang=js&"
export * from "./commonDocument.vue?vue&type=script&lang=js&"
import style0 from "./commonDocument.vue?vue&type=style&index=0&id=98b7d33a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b7d33a",
  null
  
)

export default component.exports